import React from 'react';
import ConsignedTableUI from '../consignedTableUI/ConsignedTableUI';
import { CONSIGNED_PLACEHOLDER_ROWS } from './consignedInventoryConstants';

/**
 * ConsignedTable (SCAFFOLD)
 * Static table + common BasicPagination (matches FIM dashboard).
 * TODO(team): render real rows from the API and wire column sort + pagination
 * (pass totalRecords / pageNumber / handleChange from the API response).
 */
const ConsignedTable = ({
    rows = CONSIGNED_PLACEHOLDER_ROWS,
    totalRecords = 0,
    recordsPerPage = 25,
    first = 0,
    onPageChange = () => {},
    onSortChange,
    sortField,
    sortOrder,
}) => {
    return (
        <ConsignedTableUI
            data={rows}
            totalRecords={totalRecords}
            rows={recordsPerPage}
            first={first}
            onPageChange={onPageChange}
            onSortChange={onSortChange}
            sortField={sortField}
            sortOrder={sortOrder}
        />
    );
};

export default ConsignedTable;
